module.exports = __webpack_public_path__ + "img/profile-remove.826becab.svg";